import { Button, PrimaryButton } from '@cb/apricot-react'
import { formatDateTime, DATETIME_FORMATS } from '@myap/ui-library'
import { useSaveStudentScoreSendMutation } from '../../hooks'
import ModalHeader from '../_common/apricot/ModalHeader'
import ModalFooter from '../_common/apricot/ModalFooter'
import { STATUS_LOADING } from '../_common/reactquery'

function CancelButton({ nextStepFunc }) {
  return (
    <Button small onClick={() => nextStepFunc(0)}>
      Cancel
    </Button>
  )
}

function ConfirmButton({ nextStepFunc, saveScoreSendOptOut, disabled, loading }) {
  return (
    <PrimaryButton
      small
      loading={loading}
      disabled={disabled}
      onClick={() => {
        saveScoreSendOptOut({}, { onSuccess: () => nextStepFunc(2) })
      }}
    >
      Confirm
    </PrimaryButton>
  )
}

function ScoreSendOptOut({ nextStepFunc, educationPeriodCd, diSelectionEndDate }) {
  const [confirmCheckbox1, setConfirmCheckbox1] = useState(false)
  const [confirmCheckbox2, setConfirmCheckbox2] = useState(false)
  const [confirmCheckbox3, setConfirmCheckbox3] = useState(false)
  const [confirmCheckbox4, setConfirmCheckbox4] = useState(false)

  const {
    mutate: saveScoreSendOptOut,
    status: saveScoreSendOptOutStatus,
  } = useSaveStudentScoreSendMutation({
    educationPeriodCd,
    optOut: true,
  })

  return (
    <>
      <ModalHeader
        isDismissable={false}
        title="Confirm You Don’t Want to Choose a Free Score Send Recipient"
      />
      <div className="cb-modal-content">
        <p>
          You&#39;ve indicated you don&#39;t want to select a recipient for your score report at
          this time. You can go to the Free Score Sends page at any time to learn more about sending
          AP score reports and select your recipient if you change your mind.
        </p>
        <p>Please confirm the following:</p>
        <div className="cb-spacerv-16" />
        <div className="cb-checkbox cb-margin-bottom-24">
          <label htmlFor="confirmOption1">
            <input
              type="checkbox"
              name="confirmOption1"
              id="confirmOption1"
              className="cb-checkbox"
              onChange={() => setConfirmCheckbox1(!confirmCheckbox1)}
              checked={confirmCheckbox1}
            />
            <span className="cb-label">
              I understand that my AP Exam scores will not be sent to any college, university, or
              scholarship organization.
            </span>
          </label>
        </div>
        <div className="cb-checkbox cb-margin-bottom-24">
          <label htmlFor="confirmOption2">
            <input
              type="checkbox"
              name="confirmOption2"
              id="confirmOption2"
              className="cb-checkbox"
              onChange={() => setConfirmCheckbox2(!confirmCheckbox2)}
              checked={confirmCheckbox2}
            />
            <span className="cb-label">
              I understand that an official AP Score Report allows the college or university I
              attend to assign college credit or placement, if applicable. Self-reporting of scores
              does not mean that the college or university I attend will accept those scores for
              college credit.
            </span>
          </label>
        </div>
        <div className="cb-checkbox cb-margin-bottom-24">
          <label htmlFor="confirmOption3">
            <input
              type="checkbox"
              name="confirmOption3"
              id="confirmOption3"
              className="cb-checkbox"
              onChange={() => setConfirmCheckbox3(!confirmCheckbox3)}
              checked={confirmCheckbox3}
            />
            <span className="cb-label">
              I have until{' '}
              <strong>
                {formatDateTime(diSelectionEndDate, DATETIME_FORMATS.longMonthDayYear)}
              </strong>{' '}
              to change my mind and designate a free score send recipient on the Free Score Sends
              page in AP Students.
            </span>
          </label>
        </div>
        <div className="cb-checkbox cb-margin-bottom-24">
          <label htmlFor="confirmOption4">
            <input
              type="checkbox"
              name="confirmOption4"
              id="confirmOption4"
              className="cb-checkbox"
              onChange={() => setConfirmCheckbox4(!confirmCheckbox4)}
              checked={confirmCheckbox4}
            />
            <span className="cb-label">
              If I decide to send scores after{' '}
              <strong>
                {formatDateTime(diSelectionEndDate, DATETIME_FORMATS.longMonthDayYear)}
              </strong>
              , I understand I must submit the request through the AP online score reporting system
              and I will be charged a fee for each score report I want to have sent.
            </span>
          </label>
        </div>
      </div>
      <ModalFooter
        actions={[
          () => CancelButton({ nextStepFunc }),
          () =>
            ConfirmButton({
              nextStepFunc,
              saveScoreSendOptOut,
              saveScoreSendOptOutStatus,
              disabled:
                !confirmCheckbox1 ||
                !confirmCheckbox2 ||
                !confirmCheckbox3 ||
                !confirmCheckbox4 ||
                saveScoreSendOptOutStatus === STATUS_LOADING,
              loading: saveScoreSendOptOutStatus === STATUS_LOADING,
            }),
        ]}
      />
    </>
  )
}

export default ScoreSendOptOut
